document.addEventListener("DOMContentLoaded", () => {
  ResellerCart.init();
  CustomCheckoutForm.init();
  // CustomProductFilters.init();
});

function toggleCheckoutForm() {
  const form = document.querySelector(".checkout-form-container");
  if (form) {
    form.style.display = form.style.display === "block" ? "none" : "block";
    form.classList.toggle("active");
  }
}

function setError(id, message) {
  const el = document.getElementById(id);
  if (el) el.textContent = message;
}

function formatCurrency(value, currencyCode) {
  if (currencyCode === "CHF") {
    return `${value.toFixed(2)} CHF`;
  }
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

const ResellerCart = {
  formSelector: ".reseller-product-form",
  drawerSelector: "#Cart-Drawer",
  cartKey: "localResellerCart",
  cartNoteKey: "localResellerCartNote",

  init() {
    this.cacheDom();
    this.bindEvents();
    this.loadCartFromStorage();
  },

  cacheDom() {
    this.forms = document.querySelectorAll(this.formSelector);
    this.drawer = document.querySelector(this.drawerSelector);
    this.wrapper = document.querySelector("#wrapper");
    this.cartCountBadge = document.querySelector(".float_count");
  },

  bindEvents() {
    this.forms.forEach((form) => {
      const selects = form.querySelectorAll(".js-product-option-input");
      const button = form.querySelector(".single-add-to-cart-button");
      const minus = form.querySelector(".qty-btn.minus");
      const plus = form.querySelector(".qty-btn.plus");

      selects.forEach((select) => {
        select.addEventListener("change", () => this.handleVariantChange(form));
      });

      if (button && !button.classList.contains("out-of-stock")) {
        button.addEventListener("click", (e) => {
          e.preventDefault();
          this.handleAddToLocalCart(form);
        });
      }

      if (minus && plus) {
        minus.addEventListener("click", () => this.updateQuantity(form, -1));
        plus.addEventListener("click", () => this.updateQuantity(form, 1));
      }
    });

    document.querySelectorAll("[data-drawer-toggle]").forEach((btn) => {
      btn.addEventListener("click", () => this.openDrawer());
    });

    document.querySelectorAll(".thb-close").forEach((btn) => {
      btn.addEventListener("click", () => this.closeDrawer());
    });
  },

  handleVariantChange(form) {
      // console.log("variants 1:");
    const selects = form.querySelectorAll(".js-product-option-input");
    const selectedValues = Array.from(selects).map((sel) => sel.value);
    const variants = JSON.parse(form.dataset.variants || "[]");
    // console.log("variants :", variants);
    const matchedVariant = variants.find((variant) =>
      variant.options.every((opt, i) => opt === selectedValues[i])
    );

    const moneyEl = document.querySelector(".money[doubly-currency]");
    const currencyCode = moneyEl?.getAttribute("doubly-currency") || "USD";

    if (matchedVariant) {
      form.dataset.variantId = matchedVariant.id;
      form.dataset.image = matchedVariant.featured_image?.src || "";
      form.dataset.finalPrice = (matchedVariant.price / 100).toFixed(2);
      form.dataset.available = matchedVariant.available;
      form.dataset.inventoryQuantity = matchedVariant.inventory_quantity || 0;

      const img = form.querySelector(".variant-preview-image");
      if (img && matchedVariant.featured_image?.src) {
        img.src = matchedVariant.featured_image.src.replace(
          /(_[a-z]+)?\.(jpg|png|webp|jpeg)/i,
          "_75x75.$2"
        );
      }

      // 👉 Discount calculation
      const discountPercent = parseFloat(form.dataset.discount || "0");
      const originalPrice = matchedVariant.price / 100;
      const discountAmount = (originalPrice * discountPercent) / 100;
      const discountedPrice = originalPrice - discountAmount;

      // 👉 Update price UI
      const priceDisplay = form.querySelector(".variant-price-display");
      if (priceDisplay) {
        const discountedEl = priceDisplay.querySelector(".discounted-price");
        const originalEl = priceDisplay.querySelector(".original-price");
        const labelEl = priceDisplay.querySelector(".discount-label");

        if (discountedEl){
          let dp = formatCurrency(
            discountedPrice,
            currencyCode
          );
          discountedEl.textContent = `Wholesell : ${dp}`
        }
        if (originalEl){
          console.log("ddd :", formatCurrency(originalPrice, currencyCode));
          let orgPrice = formatCurrency(originalPrice, currencyCode);
          originalEl.textContent = `RRP : ${orgPrice}`;
        }
        if (labelEl) labelEl.textContent = `${discountPercent}% OFF`;
      }

      // 👉 Show/hide based on availability
      const warning = form.querySelector(".inventory-warning");
      if (warning) warning.style.display = "none";

      const addToCartBtn = form.querySelector(".single-add-to-cart-button");
      const soldOutMessage = form.querySelector(".stock-out-of-stock");

      if (matchedVariant.available) {
        addToCartBtn.style.display = "flex";
        addToCartBtn.disabled = false;
        if (soldOutMessage) soldOutMessage.style.display = "none";
      } else {
        addToCartBtn.style.display = "none";
        if (soldOutMessage) soldOutMessage.style.display = "block";
      }
    }
  },

  updateQuantity(form, delta) {
    const qtyValueEl = form.querySelector(".qty-value");
    if (!qtyValueEl) return;
    let currentQty = parseInt(qtyValueEl.textContent, 10);
    currentQty = isNaN(currentQty) ? 1 : currentQty + delta;
    if (currentQty < 1) currentQty = 1;
    qtyValueEl.textContent = currentQty;
  },

  handleAddToLocalCart(form) {
    const button = form.querySelector(".single-add-to-cart-button");
    const btnText = button.querySelector(".single-add-to-cart-button--text");
    const spinner = button.querySelector(".spinner_2");

    // Show spinner and hide text
    if (btnText) btnText.style.display = "none";
    if (spinner) spinner.style.display = "block";

    setTimeout(() => {
      const dataset = form.dataset;
      const available = dataset.available === "true";
      const inventoryQuantity = parseInt(dataset.inventoryQuantity, 10) || 0;
      const quantityEl = form.querySelector(".qty-value");
      const quantity = quantityEl
        ? parseInt(quantityEl.textContent, 10) || 1
        : 1;
      const warning = form.querySelector(".inventory-warning");

      if (!available || quantity > inventoryQuantity) {
        if (warning) {
          warning.textContent = `Only ${inventoryQuantity} in stock. Please adjust the quantity.`;
          warning.style.display = "block";
        }
        if (btnText) btnText.style.display = "inline-block";
        if (spinner) spinner.style.display = "none";
        return;
      }

      const selectedOptions = Array.from(
        form.querySelectorAll(".js-product-option-input")
      ).map((sel) => ({
        name: sel.name,
        value: sel.value,
      }));

      const moneyEl = document.querySelector(".money[doubly-currency]");
      const currencyCode = moneyEl?.getAttribute("doubly-currency") || "USD";
      const basePrice = parseFloat(dataset.finalPrice);
      const discountPercent = parseFloat(dataset.discount || "0");
      const discountedPrice = discountPercent
        ? basePrice - (basePrice * discountPercent) / 100
        : basePrice;
      const finalPriceFormatted = formatCurrency(discountedPrice, currencyCode);

      const newItem = {
        productId: dataset.productId,
        variantId: dataset.variantId,
        title: dataset.title,
        url: dataset.url,
        image: dataset.image,
        finalPrice: finalPriceFormatted,
        unitPrice: dataset.unitPrice,
        unitPriceRefValue: dataset.unitPriceRefValue,
        unitPriceRefUnit: dataset.unitPriceRefUnit,
        sellingPlan: dataset.sellingPlan,
        discounts: dataset.discounts ? JSON.parse(dataset.discounts) : [],
        properties: dataset.properties ? JSON.parse(dataset.properties) : [],
        options: selectedOptions,
        quantity,
        timestamp: Date.now(),
      };

      const cart = this.getCart();
      const existingIndex = cart.findIndex(
        (item) => item.variantId === newItem.variantId
      );

      if (existingIndex !== -1) {
        const currentQty = cart[existingIndex].quantity || 0;
        const newQty = currentQty + quantity;

        if (newQty > inventoryQuantity) {
          if (warning) {
            warning.textContent = `Only ${inventoryQuantity} in stock. You already have ${currentQty} in cart.`;
            warning.style.display = "block";
          }
          if (btnText) btnText.style.display = "inline-block";
          if (spinner) spinner.style.display = "none";
          return;
        }

        cart[existingIndex].quantity = newQty;
      } else {
        // cart.push(newItem);
        cart.unshift(newItem);
      }

      localStorage.setItem(this.cartKey, JSON.stringify(cart));
      this.renderLocalCart();
      this.updateCartCount();
      this.openDrawer();

      if (warning) warning.style.display = "none";

      // Restore button text and hide spinner
      if (btnText) btnText.style.display = "block";
      if (spinner) spinner.style.display = "none";
    }, 1000); // 1 second delay
  },

  getCart() {
    const cart = localStorage.getItem(this.cartKey);
    return cart ? JSON.parse(cart) : [];
  },

  getCartPayload() {
    const cart = this.getCart();
    return cart.map((item) => ({
      variantId: item.variantId,
      quantity: item.quantity,
    }));
  },

  loadCartFromStorage() {
    this.renderLocalCart();
    this.updateCartCount();
  },

  renderLocalCart() {
    if (!this.drawer) return;
    const contentContainer = this.drawer.querySelector(".side-panel-content");
    if (!contentContainer) return;
    contentContainer.style.display = "block";
    const cart = this.getCart();
    contentContainer.innerHTML = "";

    if (!cart.length) {
      contentContainer.innerHTML =
      `<div class="cart-empty text-center">
        <div class="section">
          <figure>
            
      <svg fill="var(--color-text)" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 135.3 169.7" style="enable-background:new 0 0 135.3 169.7;" xml:space="preserve"><path d="M130.7,168.8L130.7,168.8C130.6,168.8,130.6,168.8,130.7,168.8C130.6,168.8,130.7,168.8,130.7,168.8z M35.2,40.3
            c2.2,0,2.5-0.2,2.5-2.5c0-15.8,14.3-32,30-32c15.7,0,29.9,16.1,29.9,31.9c0,2.3,0.3,2.6,2.5,2.6c2.2,0,2.5-0.3,2.5-2.6
            c0-20.4-14.8-36.9-35-36.9s-35,16.6-35,37C32.7,40.1,32.9,40.3,35.2,40.3z M134.7,163.8l-4-110c-0.1-2.2-1.8-4-4-4H8.7
            c-2.2,0-3.9,1.8-4,4l-4,110c0,1.1,0.4,2.9,1.1,3.7c0.8,0.8,1.8,1.3,2.9,1.3h126c2.2,0,4-1.8,4-4.1
            C134.7,164.4,134.7,164,134.7,163.8z M5.7,163.8l4-109h116l4,109H5.7z M48.7,98.8c0-4-2.3-8-5-8c-2.7,0-5,4-5,8c0,4,2.3,8,5,8
            C46.3,106.8,48.7,102.8,48.7,98.8z M91.8,90.9c-2.7,0-5.1,3.8-5.1,7.9c0,4,2.3,8,5,8s5-4,5-8C96.7,94.7,94.4,90.9,91.8,90.9z
             M87.7,121.8h-39c-1.3,0-3,1.6-3,3c0,1.4,1.7,3,3,3h39c1.3,0,2-1.6,2-3C89.7,123.4,89,121.8,87.7,121.8z"></path>
      </svg>
      
          </figure>
          <p class="cart-empty">Your cart is currently empty.</p>
        </div>
      </div>`;
      return;
    }

    const list = document.createElement("ul");
    list.className = "mini-cart cart_list product_list_widget local-cart-items";

    let subtotal = 0;

    const moneyEl = document.querySelector(".money[doubly-currency]");
    const currencyCode = moneyEl?.getAttribute("doubly-currency") || "USD";
    // console.log("currencyCode", currencyCode);
    cart.forEach((item, index) => {
      const priceNumber = parseFloat(item.finalPrice.replace(/[^0-9.-]+/g, ""));
      subtotal += priceNumber * item.quantity;

      const li = document.createElement("li");
      li.className = "mini_cart_item";
      li.id = `CartDrawerItem-${index + 1}`;
      li.innerHTML = `
        <button class="local-cart-remove-btn" data-index="${index}">
          <span class="remove-text">x</span>
          <span class="remove-spinner spinner_" style="display:none;"></span>
        </button>
        <a href="${item.url}" title="${item.title}">
          ${
            item.image
              ? `<img src="${item.image}" alt="${item.title}" width="75" height="75" loading="lazy" />`
              : `<div class="thb-placeholder" style="width: 75px; height:75px;">
                <svg width="75" height="75" viewBox="0 0 75 75" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="75" height="75" fill="#eee"/></svg>
              </div>`
          }
        </a>
        <div class="mini_cart_item_content">
          <h3><a href="${item.url}" title="${item.title}">${item.title}</a></h3>
          ${
            item.sellingPlan
              ? `<div class="properties"><span class="selling-plan">${item.sellingPlan}</span></div>`
              : ""
          }
          ${
            item.options?.length
              ? `
            <div class="mini_cart_item__meta-text">
              ${item.options
                .map((opt) => `<span>${opt.name}:</span> ${opt.value}<br/>`)
                .join("")}
            </div>`
              : ""
          }
          <span class="price">
            <span class="mini-quantity">${item.quantity} ×</span>
            <span class="amount">${item.finalPrice}</span>
            ${
              item.unitPrice
                ? `
              <small class="unit-price">
                ${item.unitPrice}
                <span class="unit-price-separator">/</span>
                ${item.unitPriceRefValue > 1 ? item.unitPriceRefValue : ""}${
                    item.unitPriceRefUnit
                  }
              </small>`
                : ""
            }
          </span>
          <div class="quantity-selector_custom" data-index="${index}">
            <button type="button" class="qty-btn_custom minus">−</button>
            <span class="qty-input_custom">${item.quantity}</span>
            <button type="button" class="qty-btn_custom plus">+</button>
          </div>
        </div>
      `;
      list.appendChild(li);
    });

    contentContainer.appendChild(list);

    const note = localStorage.getItem(this.cartNoteKey) || "";
    // console.log("subtotal", subtotal);
    const footer = document.createElement("div");
    footer.className = "local-cart-footer";
    footer.style = "padding: 1rem; border-top: 1px solid #eee;";

    footer.innerHTML = `
      <div class="cart-note-container" style="margin-bottom: 1rem;">
        <label for="cart-note" style="display:block; margin-bottom: 0.5rem;">Add a note to your order:</label>
        <textarea id="cart-note" name="note" rows="2" style="width: 100%; padding: 0.5rem;">${note}</textarea>
      </div>
      <div class="cart-subtotal" style="margin-bottom: 1rem;">
        <strong>Subtotal:</strong> ${formatCurrency(subtotal, currencyCode)}
      </div>
      <button type="button" class="custom_checkout-form" style="display: block; text-align: center; background: black; color: white; padding: 0.75rem;">
        Process to checkout
      </button>
    `;

    contentContainer.appendChild(footer);

    const noteEl = footer.querySelector("#cart-note");
    if (noteEl) {
      noteEl.addEventListener("input", (e) => {
        localStorage.setItem(this.cartNoteKey, e.target.value);
      });
    }

    this.bindRemoveEvents();
    this.bindDrawerQuantityEvents();
    this.bindCheckoutEvent();
    this.bindCloseCheckoutForm();
  },

  bindRemoveEvents() {
    const removeButtons = this.drawer.querySelectorAll(".local-cart-remove-btn");
    removeButtons.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const button = e.currentTarget;
        const index = parseInt(button.dataset.index, 10);
  
        const textEl = button.querySelector(".remove-text");
        const spinnerEl = button.querySelector(".remove-spinner");
        if (textEl) textEl.style.display = "none";
        if (spinnerEl) spinnerEl.style.display = "block";
  
        setTimeout(() => {
          this.removeItemFromLocalCart(index);
        }, 1000); // wait 1 second before removing
      });
    });
  },


  bindCheckoutEvent() {
    const checkoutBtn = document.querySelector(".custom_checkout-form");
    if (checkoutBtn) {
      checkoutBtn.addEventListener("click", () => {
        this.handleCheckout();
      });
    }
  },

  bindCloseCheckoutForm() {
    const formCloseBtn = document.querySelector(".close_form__button");
    if (formCloseBtn) {
      formCloseBtn.addEventListener("click", () => {
        // console.log("clicked on close button");
        this.handleCloseCheckoutForm();
      });
    }
  },

  bindDrawerQuantityEvents() {
    const quantitySelectors = this.drawer.querySelectorAll(
      ".quantity-selector_custom"
    );
    quantitySelectors.forEach((selector) => {
      const index = parseInt(selector.dataset.index, 10);
      const minusBtn = selector.querySelector(".qty-btn_custom.minus");
      const plusBtn = selector.querySelector(".qty-btn_custom.plus");
      const input = selector.querySelector(".qty-input_custom");

      if (minusBtn) {
        minusBtn.addEventListener("click", () => {
          this.updateDrawerItemQuantity(index, -1);
        });
      }

      if (plusBtn) {
        plusBtn.addEventListener("click", () => {
          this.updateDrawerItemQuantity(index, 1);
        });
      }

      if (input) {
        input.addEventListener("change", (e) => {
          const value = parseInt(e.target.value, 10);
          this.setDrawerItemQuantity(
            index,
            isNaN(value) || value < 1 ? 1 : value
          );
        });
      }
    });
  },

  removeItemFromLocalCart(indexToRemove) {
    const cart = this.getCart();
    if (cart.length > indexToRemove) {
      cart.splice(indexToRemove, 1);
      localStorage.setItem(this.cartKey, JSON.stringify(cart));
      this.renderLocalCart();
      this.updateCartCount();
    }
  },

  updateDrawerItemQuantity(index, delta) {
    const cart = this.getCart();
    const item = cart[index];
    if (!item) return;
    const newQty = Math.max(1, item.quantity + delta);
    cart[index].quantity = newQty;
    localStorage.setItem(this.cartKey, JSON.stringify(cart));
    this.renderLocalCart();
    this.updateCartCount();
  },

  handleCheckout() {
    // const cartItems = this.getCart();
    // toggleCheckoutForm();
    // this.closeDrawer();
    console.log("helo from checkout");
    document.querySelectorAll(".thb-close").forEach((btn) => {
      btn.dispatchEvent(new MouseEvent("click", { bubbles: true }));
    });
    setTimeout(() => {
      toggleCheckoutForm();
      if (this.wrapper) this.wrapper.classList.add("open-cc");
       console.log("helo from checkout 2", this.wrapper);
    }, 500); // 3 seconds
    console.log("helo from checkout 3");
    const cartNote = localStorage.getItem(this.cartNoteKey) || "";
    const onlySelectItem = this.getCartPayload();
    // console.log("📝 Cart Note:", cartNote);
    // console.log("🛒 Cart Items:", onlySelectItem);
    // console.log("onlySelectItem:", onlySelectItem);
  },

  handleCloseCheckoutForm() {
    toggleCheckoutForm();
    if (this.wrapper) this.wrapper.classList.remove("open-cc");
  },

  setDrawerItemQuantity(index, quantity) {
    const cart = this.getCart();
    const item = cart[index];
    if (!item) return;
    cart[index].quantity = Math.max(1, quantity);
    localStorage.setItem(this.cartKey, JSON.stringify(cart));
    this.renderLocalCart();
    this.updateCartCount();
  },

  // updateCartCount() {
  //   const cart = this.getCart();
  //   const count = cart.length;
  //   if (this.cartCountBadge) {
  //     this.cartCountBadge.textContent = count;
  //   }
  // },
  updateCartCount() {
    const cart = this.getCart();
    const totalQuantity = cart.reduce((sum, item) => sum + item.quantity, 0);
    if (this.cartCountBadge) {
      this.cartCountBadge.textContent = totalQuantity;
    }
  },

  openDrawer() {
    if (!this.drawer) return;
    this.drawer.classList.add("open");
    if (this.wrapper) this.wrapper.classList.add("open-cc");
  },

  closeDrawer() {
    if (!this.drawer) return;
    this.drawer.classList.remove("open");
    if (this.wrapper) this.wrapper.classList.remove("open-cc");
  },
};

//  ==================================================== Checkout Form JS ===========================================================================

const CustomCheckoutForm = {
  countrySelectId: "billingCountry",
  stateSelectId: "billingState",
  eventDateInputId: "eventDate",
  formId: "customCheckoutForm",
  checkoutButtonId: "customCheckoutFormSubmit",

  init() {
    this.cacheDom();
    this.bindEvents();
    this.updateStates();
  },

  cacheDom() {
    this.countrySelect = document.getElementById(this.countrySelectId);
    this.stateSelect = document.getElementById(this.stateSelectId);
    this.eventDateInput = document.getElementById(this.eventDateInputId);
    this.checkoutButton = document.getElementById(this.checkoutButtonId);
    this.form = document.getElementById(this.formId);
    this.stateWrapper = this.stateSelect.closest(".form-group");
    this.originalStateWrapper = this.stateWrapper.cloneNode(true); // Keep a clone
    this.stateContainer = this.stateWrapper.parentElement;

    this.emailInput = document.getElementById("contactEmail");
    this.mobileInput = document.getElementById("phoneNumber");
    this.termsCheckbox = document.getElementById("termsCheckbox");

    this.emailError = document.getElementById("emailError");
    this.mobileError = document.getElementById("mobileError");
    this.termsError = document.getElementById("termsError");
  },

  bindEvents() {
    if (this.countrySelect) {
      this.countrySelect.addEventListener(
        "change",
        this.updateStates.bind(this)
      );
    }

    if (this.eventDateInput) {
      this.eventDateInput.addEventListener(
        "focus",
        this.enableDateInput.bind(this)
      );
      this.eventDateInput.addEventListener(
        "blur",
        this.resetDatePlaceholder.bind(this)
      );
    }

    if (this.checkoutButton) {
      this.checkoutButton.addEventListener(
        "click",
        this.handleSubmit.bind(this)
      );
    }
  },

  enableDateInput() {
    this.eventDateInput.type = "date";
  },

  resetDatePlaceholder() {
    if (!this.eventDateInput.value) {
      this.eventDateInput.type = "text";
      this.eventDateInput.placeholder = "dd-mm-yyyy";
    }
  },

  updateStates() {
    const selectedOption =
      this.countrySelect.options[this.countrySelect.selectedIndex];
    const provincesJSON = selectedOption.getAttribute("data-provinces");
    this.stateSelect.innerHTML = "";
    // console.log("provincesJSON:", provincesJSON);
    try {
      const provinces = JSON.parse(provincesJSON);
      if (Array.isArray(provinces) && provinces.length > 0) {
        if (!this.stateContainer.contains(this.stateWrapper)) {
          this.stateWrapper = this.originalStateWrapper.cloneNode(true); // fresh clone
          this.stateSelect = this.stateWrapper.querySelector("#billingState"); // re-bind reference
          const countryGroup = this.countrySelect.closest(".form-group");
          if (countryGroup && countryGroup.parentNode) {
            countryGroup.parentNode.insertBefore(
              this.stateWrapper,
              countryGroup.nextSibling
            );
          } else {
            this.stateContainer.appendChild(this.stateWrapper); // fallback
          }
        }

        this.stateSelect.disabled = false;
        const defaultOption = document.createElement("option");
        defaultOption.value = "";
        defaultOption.textContent = "Select State/Province";
        this.stateSelect.appendChild(defaultOption);

        provinces.forEach(([value, name]) => {
          const option = document.createElement("option");
          option.value = value;
          option.textContent = name;
          this.stateSelect.appendChild(option);
        });
      } else {
        this.removeStateField();
      }
    } catch (err) {
      this.removeStateField();
      console.error("Invalid province data:", err);
    }
  },

  removeStateField() {
    if (this.stateWrapper && this.stateWrapper.parentElement) {
      this.stateWrapper.parentElement.removeChild(this.stateWrapper);
    }
  },

  setNoStateOption() {
    if (this.stateSelect) {
      const formGroup = this.stateSelect.closest(".form-group");
      if (formGroup && formGroup.parentNode) {
        formGroup.parentNode.removeChild(formGroup);
      }
      this.stateSelect = null; // Clear reference
    }
  },

  getCart() {
    const cart = localStorage.getItem("localResellerCart");
    return cart ? JSON.parse(cart) : [];
  },

  getCartPayload() {
    const cart = this.getCart();
    return cart.map((item) => ({
      variantId: item.variantId,
      quantity: item.quantity,
    }));
  },

  // Checkout form submit button
  handleSubmit(event) {
    event.preventDefault();
    const isValid = this.validateForm();
    if (!isValid) return;
    this.logFormValues();
  },

  // Validation of checkout form
  validateForm() {
    let isValid = true;

    [
      "firstNameError",
      "lastNameError",
      "emailError",
      "mobileError",
      "companyNameError",
      "vatError",
      "billingCountryError",
      "billingStateError",
      "cityError",
      "zipCodeError",
      "addressError",
      "termsError",
    ].forEach((id) => setError(id, ""));

    const firstName = document.getElementById("firstName").value.trim();
    if (!firstName) {
      setError("firstNameError", "First name is required.");
      isValid = false;
    }

    const lastName = document.getElementById("lastName").value.trim();
    if (!lastName) {
      setError("lastNameError", "Last name is required.");
      isValid = false;
    }

    const email = document.getElementById("contactEmail").value.trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) {
      setError("emailError", "Email is required.");
      isValid = false;
    } else if (!emailRegex.test(email)) {
      setError("emailError", "Email format is invalid.");
      isValid = false;
    }

    const phone = document.getElementById("phoneNumber").value.trim();
    if (!phone) {
      setError("mobileError", "Phone number is required.");
      isValid = false;
    }

    const companyName = document.getElementById("companyName").value.trim();
    if (!companyName) {
      setError("companyNameError", "Company name is required.");
      isValid = false;
    }

    const vat = document.getElementById("vat").value.trim();
    if (!vat) {
      setError("vatError", "VAT number is required.");
      isValid = false;
    }

    const billingCountry = document
      .getElementById("billingCountry")
      .value.trim();
    if (!billingCountry) {
      setError("billingCountryError", "Country/Region is required.");
      isValid = false;
    }

    const billingStateElement = document.getElementById("billingState");
    if (billingStateElement) {
      const billingState = billingStateElement.value.trim();
      if (!billingState) {
        setError("billingStateError", "State is required.");
        isValid = false;
      }
    }

    const city = document.getElementById("city").value.trim();
    if (!city) {
      setError("cityError", "City is required.");
      isValid = false;
    }

    const zipCode = document.getElementById("zipCode").value.trim();
    if (!zipCode) {
      setError("zipCodeError", "Zip/Postal code is required.");
      isValid = false;
    }

    const address = document.getElementById("address").value.trim();
    if (!address) {
      setError("addressError", "Address is required.");
      isValid = false;
    }

    const termsChecked = document.getElementById("termsCheckbox").checked;
    if (!termsChecked) {
      setError("termsError", "You must agree to the Terms & Conditions.");
      isValid = false;
    }

    return isValid;
  },

  // Show error pop if any error is occured
  showErrorPopup(message) {
    const popup = document.createElement("div");
    popup.className = "error-popup";
    popup.innerHTML = `
      <div class="popup-content">
        <span class="popup-message">${message}</span>
        <button class="popup-close">&times;</button>
      </div>
    `;
    document.body.appendChild(popup);
    // Auto remove after 3 seconds
    setTimeout(() => {
      popup.remove();
    }, 3000);
    popup.querySelector(".popup-close").addEventListener("click", () => {
      popup.remove();
    });
  },

  // Show Success message pop up

  showSuccessMessage(message) {
    const popup = document.createElement("div");
    popup.className = "success-popup";
    popup.innerHTML = `
      <div class="popup-content">
        <span class="popup-message">${message}</span>
        <button class="popup-close">&times;</button>
      </div>
    `;
    document.body.appendChild(popup);
    setTimeout(() => {
      popup.remove();
    }, 3000);
    popup.querySelector(".popup-close").addEventListener("click", () => {
      popup.remove();
    });
  },

  // Show a loader on checkout form when api call is running
  showCheckoutLoader() {
    const loader = document.createElement("div");
    loader.className = "checkout-loader";
    loader.innerHTML = ` <span class="loader_circle"></span>`;
    document.body.appendChild(loader);
  },

  // remove loader
  removeCheckoutLoader() {
    const existing = document.querySelector(".checkout-loader");
    if (existing) existing.remove();
  },

  // Draft order create API calling
  async logFormValues() {
    this.showCheckoutLoader();
    const formData = new FormData(this.form);
    const selectedItems = this.getCartPayload();
    const note = localStorage.getItem("localResellerCartNote") || "";
    // console.log("selectedItems :", selectedItems);
    const values = {
      cart_items: selectedItems,
      cart_note: note,
    };
    for (let [key, value] of formData.entries()) {
      values[key] = value;
    }
    // console.log("Form Values:", values);
    try {
      const res = await fetch("http://localhost:3000/test-egm", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
      });
      const json = await res.json();
      this.removeCheckoutLoader();
      if (json.status === 200) {
        console.log("Order created:", json);
        this.showSuccessMessage("Your order has placed , Thank you!");
      } else {
        const errorData = json?.details[0]?.message;
        console.log("Order cerrorData:", errorData);
        this.showErrorPopup(errorData);
      }
    } catch (err) {
      console.error("❌ Network error:", err);
      this.removeCheckoutLoader();
    }
  },
};

const CustomProductFilters = {
  dropdownToggleId: "dropdown-toggle",
  dropdownMenuId: "dropdown-menu",
  availabilityToggleId: "availability-toggle",
  availabilityMenuId: "availability-menu",
  checkboxClass: "filter-checkbox",
  availabilityCheckboxClass: "availability-checkbox",
  resetButtonId: "reset-filters",
  productsClass: "main-single-product",

  init() {
    this.cacheDom();
    this.bindEvents();
  },

  cacheDom() {
    // this.dropdownToggle = document.getElementById(this.dropdownToggleId);
    // this.dropdownMenu = document.getElementById(this.dropdownMenuId);
    // this.availabilityToggle = document.getElementById(
    //   this.availabilityToggleId
    // );
    // this.availabilityMenu = document.getElementById(this.availabilityMenuId);
    this.tagCheckboxes = document.querySelectorAll(`.${this.checkboxClass}`);
    this.availabilityCheckboxes = document.querySelectorAll(
      `.${this.availabilityCheckboxClass}`
    );
    // this.resetButton = document.getElementById(this.resetButtonId);
    this.products = document.querySelectorAll(`.${this.productsClass}`);
  },

  bindEvents() {
    // this.dropdownToggle.addEventListener("click", () =>
    //   this.toggleDropdown(this.dropdownMenu)
    // );
    // this.availabilityToggle.addEventListener("click", () =>
    //   this.toggleDropdown(this.availabilityMenu)
    // );

    this.tagCheckboxes.forEach((checkbox) =>
      checkbox.addEventListener("change", () => this.applyFilters())
    );
    this.availabilityCheckboxes.forEach((checkbox) =>
      checkbox.addEventListener("change", () => this.applyFilters())
    );

    // this.resetButton.addEventListener("click", () => this.resetFilters());

    // document.addEventListener("click", (e) => this.handleOutsideClick(e));
  },

  toggleDropdown(menu) {
    menu.style.display = menu.style.display === "block" ? "none" : "block";
  },

  handleOutsideClick(e) {
    if (!e.target.closest(".dropdown")) {
      this.dropdownMenu.style.display = "none";
      this.availabilityMenu.style.display = "none";
    }
  },

  getSelectedTags() {
    return Array.from(this.tagCheckboxes)
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value);
  },

  getSelectedAvailability() {
    return Array.from(this.availabilityCheckboxes)
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value);
  },

  applyFilters() {
    const selectedTags = this.getSelectedTags();
    const selectedAvailability = this.getSelectedAvailability();

    this.products.forEach((product) => {
      const productTags = product
        .getAttribute("data-tags")
        .split(",")
        .map((tag) => tag.trim());
      const productAvailability = product.getAttribute(
        "data-product-available"
      ); // "true" or "false"

      let matchesTag =
        selectedTags.length === 0 ||
        selectedTags.some((tag) => productTags.includes(tag));
      let matchesAvailability =
        selectedAvailability.length === 0 ||
        selectedAvailability.includes(productAvailability);

      if (matchesTag && matchesAvailability) {
        product.parentElement.style.display = "block";
      } else {
        product.parentElement.style.display = "none";
      }
    });
  },

  resetFilters() {
    this.tagCheckboxes.forEach((checkbox) => (checkbox.checked = false));
    this.availabilityCheckboxes.forEach(
      (checkbox) => (checkbox.checked = false)
    );

    this.products.forEach(
      (product) => (product.parentElement.style.display = "block")
    );
  },
};
